import { createFileRoute } from "@tanstack/react-router";
import { IFrameProductGridListQuickAction } from "@/pages/ProductGridListQuickAction";

export const Route = createFileRoute("/product_grid_quick_action")({
  validateSearch: (search: Record<string, unknown>) => {
    const position = search.position as string;

    if (import.meta.env.DEV) {
      return {
        position: position || "pim.product-grid.action-bar",
      };
    }

    // In production, enforce strict validation
    if (position !== "pim.product-grid.action-bar") {
      const response = new Response(
        "Invalid position parameter. Expected: pim.product-grid.action-bar",
        {
          status: 400,
          statusText: "Bad Request",
        },
      );
      throw response;
    }

    return {
      position,
    };
  },
  component: IFrameProductGridListQuickAction,
});
